import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IBlocksResponse } from '../models';
import { dtmConst } from '..';

export const getBlocks = async () => {
  const { data } = await $apiV2.get<{ data: IBlocksResponse }>('/dtm/blocks');

  return { block: data.data };
};

export const useBlocks = () => {
  const { data, ...args } = useQuery({
    queryKey: [dtmConst.queryKeys.DTM_BLOCKS],
    queryFn: getBlocks
  });

  return { ...data, ...args };
};
